import { SdmTypography } from 'components';
import React from 'react';
import { cdnUrl as CDN_URL } from 'utils/constants';

const SpeakerCard = ({ speaker, isSmDown }) => {
  return (
    <div style={{ padding: '20px 20px 20px 0' }}>
      <img
        src={
          speaker?.coverImage
            ? `${CDN_URL}/${speaker.coverImage}`
            : '/themes/custom/sdm/images/header/logo-black.svg'
        }
        alt="speaker-img"
        style={{
          height: isSmDown ? 300 : 128.5,
          width: '100%',
          objectFit: 'cover',
          objectPosition: 'top',
        }}
      />
      <SdmTypography variant={'h2Regular'} style={{ color: 'white' }}>
        {speaker.givenName} {speaker.familyName}
      </SdmTypography>
      {speaker.jobTitle && (
        <SdmTypography variant={'text'} style={{ color: 'white' }}>
          {speaker.jobTitle}
        </SdmTypography>
      )}
    </div>
  );
};

export default SpeakerCard;
